<div class="grid-layout" [class.not-available]="!selectedTimeRecord">
  <app-elevation-section [title]="weekOverview[0]?.title">
    <app-edit-transport-weekoverview
      [gridDataSource]="transportWeekOverview"
      [setWeekNo]="selectedWeekNo"
      [height]="250"
      [widthTimeTypeCategory]="150"
      [overTimeCheckActive]="overTimeCheckActive"
      [showTitle]="false">
    </app-edit-transport-weekoverview>
  </app-elevation-section>

  <app-elevation-section [title]="chartTitle">
    <dx-chart [dataSource]="barchartModel?.dataSource"
              [series]="barchartModel?.series"
              palette="violet"
              style="padding: 5px"
              [stickyHovering]="false">
      <dxo-size [height]="270" [width]="500"></dxo-size>
      <dxo-common-series-settings argumentField="period" type="stackedBar" [barWidth]="100"></dxo-common-series-settings>
      <dxo-legend verticalAlignment="bottom" horizontalAlignment="center" itemTextPosition="top"></dxo-legend>
      <dxo-tooltip [enabled]="true" location="edge" [customizeTooltip]="customizeBarChartTooltip">
        <dxo-format type="fixedPoint" [precision]="2"></dxo-format>
      </dxo-tooltip>
    </dx-chart>
  </app-elevation-section>

  <app-project-portal-approval-details-carrier-item-flows 
    [hidden]="!gridSections.ShowCarrierItemFlows"
    [selectedTimeRecord]="selectedTimeRecord"
    [carrierItemFlows]="carrierItemFlows"
    [items]="items"
    [allowEdit]="projectReadWriteAll && selectedTimeRecord">
  </app-project-portal-approval-details-carrier-item-flows>
</div>
